/**
 * AI 分析 - 产品信息卡片
 */
import React from 'react';
import { Card, Space, Descriptions, Typography } from 'antd';
import { ShoppingOutlined } from '@ant-design/icons';

const { Text } = Typography;

interface SKUInfo {
  price?: string | number;
  profit_margin?: string | number;
  target_market?: string;
  key_selling_points?: string;
}

interface AIProductInfoProps {
  skuInfo?: SKUInfo;
}

export const AIProductInfo: React.FC<AIProductInfoProps> = ({ skuInfo }) => {
  if (!skuInfo) return null;

  return (
    <Card
      title={
        <Space>
          <ShoppingOutlined style={{ color: '#52c41a' }} />
          产品信息
        </Space>
      }
      size="small"
      style={{ marginBottom: 16, background: '#f6ffed', borderColor: '#b7eb8f' }}
    >
      <Descriptions size="small" column={2}>
        {skuInfo.price && (
          <Descriptions.Item label="售价">
            <Text strong style={{ color: '#52c41a', fontSize: '16px' }}>
              ${skuInfo.price}
            </Text>
          </Descriptions.Item>
        )}
        {skuInfo.profit_margin && (
          <Descriptions.Item label="利润率">
            <Text strong style={{ color: '#faad14', fontSize: '16px' }}>
              {skuInfo.profit_margin}%
            </Text>
          </Descriptions.Item>
        )}
        {skuInfo.target_market && (
          <Descriptions.Item label="目标市场" span={2}>
            {skuInfo.target_market}
          </Descriptions.Item>
        )}
        {skuInfo.key_selling_points && (
          <Descriptions.Item label="核心卖点" span={2}>
            {skuInfo.key_selling_points}
          </Descriptions.Item>
        )}
      </Descriptions>
    </Card>
  );
};

